import moment from 'moment';
import instance from '../config/axios';

export async function createOrderHistoryReport(
  accessToken: string,
  from: Date,
  to: Date,
) {
  try {
    const response = await instance({
      method: 'POST',
      url: '/api/v1/order/report',
      data: {
        from: moment(from).format('YYYY/MM/DD'),
        to: moment(to).format('YYYY/MM/DD'),
      },
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    return response.status;
  } catch (e) {
    console.log(e);
    return false;
  }
}
